import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Shell } from "../../components/Shell";
import { AiChat } from "../../components/AiChat";
import { useLang } from "../../lib/i18n";
import { api } from "../../lib/api";
import { LayoutDashboard, Wallet, ReceiptText } from "lucide-react";
import Home from "./Home";
import Shares from "./Shares";
import Statements from "./Statements";

export default function MemberApp() {
  const { t } = useLang();
  const [brand, setBrand] = useState("Portal Ahli");

  useEffect(() => {
    api.get("/portal/me").then((r) => setBrand(r.data.tenant?.branding?.brand_name || r.data.tenant?.name || "Portal Ahli")).catch(() => {});
  }, []);

  const items = [
    { to: "/portal", end: true, icon: LayoutDashboard, label: t("dash.home"), testid: "nav-portal-home" },
    { to: "/portal/shares", icon: Wallet, label: t("dash.shares"), testid: "nav-portal-shares" },
    { to: "/portal/statements", icon: ReceiptText, label: `${t("dash.fees")} & ${t("dash.receipts")}`, testid: "nav-portal-statements" },
  ];

  return (
    <Shell items={items} brand={brand} subtitle="Portal Ahli" testid="member-portal">
      <Routes>
        <Route index element={<Home />} />
        <Route path="shares" element={<Shares />} />
        <Route path="statements" element={<Statements />} />
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
      <AiChat />
    </Shell>
  );
}
